module.exports = __webpack_public_path__ + "img/5ToolProspect.331ecb2c.svg";